// Action Constants
export const CONTENT_BROWSER_SET_CURRENT_FOLDER = 'CONTENT_BROWSER_SET_CURRENT_FOLDER';
export const CONTENT_BROWSER_SET_DISPLAY_MODE = 'CONTENT_BROWSER_SET_DISPLAY_MODE';
export const CONTENT_BROWSER_SET_SELECTED_FOLDERS = 'CONTENT_BROWSER_SET_SELECTED_FOLDERS';
export const CONTENT_BROWSER_SET_SELECTED_CONTENT = 'CONTENT_BROWSER_SET_SELECTED_CONTENT';
export const CONTENT_BROWSER_RESET_SELECTION = 'CONTENT_BROWSER_RESET_SELECTION';
export const CONTENT_BROWSER_CUT_ITEMS = 'CONTENT_BROWSER_CUT_ITEMS';
export const CONTENT_BROWSER_PASTE_ITEMS = 'CONTENT_BROWSER_PASTE_ITEMS';
export const CONTENT_BROWSER_CLEAR_CLIPBOARD = 'CONTENT_BROWSER_CLEAR_CLIPBOARD';
export const CONTENT_BROWSER_REMOVE_CLIPBOARD_ITEM = 'CONTENT_BROWSER_REMOVE_CLIPBOARD_ITEM';
export const CONTENT_BROWSER_SEARCH_REQUEST = 'CONTENT_BROWSER_SEARCH_REQUEST';
export const CONTENT_BROWSER_SEARCH_SUCCESS = 'CONTENT_BROWSER_SEARCH_SUCCESS';
export const CONTENT_BROWSER_SEARCH_FAILURE = 'CONTENT_BROWSER_SEARCH_FAILURE';
export const CONTENT_BROWSER_GET_BREADCRUMBS_REQUEST = 'CONTENT_BROWSER_GET_BREADCRUMBS_REQUEST';
export const CONTENT_BROWSER_GET_BREADCRUMBS_SUCCESS = 'CONTENT_BROWSER_GET_BREADCRUMBS_SUCCESS';
export const CONTENT_BROWSER_GET_BREADCRUMBS_FAILURE = 'CONTENT_BROWSER_GET_BREADCRUMBS_FAILURE';
export const CONTENT_BROWSER_SELECT_FOLDER = 'CONTENT_BROWSER_SELECT_FOLDER';
export const CONTENT_BROWSER_SELECT_CONTENT = 'CONTENT_BROWSER_SELECT_CONTENT';
export const CONTENT_BROWSER_SET_SEARCH_QUERY = 'CONTENT_BROWSER_SET_SEARCH_QUERY';
export const CONTENT_BROWSER_TOGGLE_SELECT_ALL = 'CONTENT_BROWSER_TOGGLE_SELECT_ALL';
export const CONTENT_BROWSER_MOVE_ITEMS_REQUEST = 'CONTENT_BROWSER_MOVE_ITEMS_REQUEST';
export const CONTENT_BROWSER_MOVE_ITEMS_SUCCESS = 'CONTENT_BROWSER_MOVE_ITEMS_SUCCESS';
export const CONTENT_BROWSER_MOVE_ITEMS_FAILURE = 'CONTENT_BROWSER_MOVE_ITEMS_FAILURE';
export const CONTENT_BROWSER_UPLOAD_STARTED = 'CONTENT_BROWSER_UPLOAD_STARTED';
export const CONTENT_BROWSER_UPLOAD_PROGRESS_UPDATED = 'CONTENT_BROWSER_UPLOAD_PROGRESS_UPDATED';
export const CONTENT_BROWSER_UPLOAD_COMPLETED = 'CONTENT_BROWSER_UPLOAD_COMPLETED';
export const CONTENT_BROWSER_UPLOAD_FAILED = 'CONTENT_BROWSER_UPLOAD_FAILED';
export const CONTENT_BROWSER_UPLOAD_CANCELLED = 'CONTENT_BROWSER_UPLOAD_CANCELLED';
export const CONTENT_BROWSER_UPLOAD_REMOVED = 'CONTENT_BROWSER_UPLOAD_REMOVED';
export const CONTENT_BROWSER_UPLOADS_CLEARED = 'CONTENT_BROWSER_UPLOADS_CLEARED';

import type { SearchParams, IH5PUploadProgress } from './types';

// Action Interfaces
export interface IContentBrowserSetCurrentFolderAction {
  type: typeof CONTENT_BROWSER_SET_CURRENT_FOLDER;
  payload: {
    folderId: string;
  };
}

export interface IContentBrowserSetDisplayModeAction {
  type: typeof CONTENT_BROWSER_SET_DISPLAY_MODE;
  payload: {
    displayMode: 'grid' | 'list';
  };
}

export interface IContentBrowserSetSelectedFoldersAction {
  type: typeof CONTENT_BROWSER_SET_SELECTED_FOLDERS;
  payload: {
    folderIds: string[];
  };
}

export interface IContentBrowserSetSelectedContentAction {
  type: typeof CONTENT_BROWSER_SET_SELECTED_CONTENT;
  payload: {
    contentIds: string[];
  };
}

export interface IContentBrowserResetSelectionAction {
  type: typeof CONTENT_BROWSER_RESET_SELECTION;
}

export interface IContentBrowserCutItemsAction {
  type: typeof CONTENT_BROWSER_CUT_ITEMS;
  payload: {
    folderIds: string[];
    contentIds: string[];
  };
}

export interface IContentBrowserPasteItemsAction {
  type: typeof CONTENT_BROWSER_PASTE_ITEMS;
  payload: {
    targetFolderId: string;
  };
}

export interface IContentBrowserClearClipboardAction {
  type: typeof CONTENT_BROWSER_CLEAR_CLIPBOARD;
}

export interface IContentBrowserRemoveClipboardItemAction {
  type: typeof CONTENT_BROWSER_REMOVE_CLIPBOARD_ITEM;
  payload: {
    itemType: 'folder' | 'content';
    itemId: string;
  };
}

export interface IContentBrowserSearchRequestAction {
  type: typeof CONTENT_BROWSER_SEARCH_REQUEST;
}

export interface IContentBrowserSearchSuccessAction {
  type: typeof CONTENT_BROWSER_SEARCH_SUCCESS;
  payload: {
    results: Array<{
      index: string;
      id: string;
      score: number;
      source: {
        name: string;
        content_type: string;
        library?: string;
      };
    }>;
    pageInfo: {
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      currentPage: number;
      totalPages: number;
      totalResults: number;
      pageSize: number;
    };
    params: SearchParams;
  };
}

export interface IContentBrowserSearchFailureAction {
  type: typeof CONTENT_BROWSER_SEARCH_FAILURE;
  payload: Error;
}

export interface IContentBrowserGetBreadcrumbsRequestAction {
  type: typeof CONTENT_BROWSER_GET_BREADCRUMBS_REQUEST;
}

export interface IContentBrowserGetBreadcrumbsSuccessAction {
  type: typeof CONTENT_BROWSER_GET_BREADCRUMBS_SUCCESS;
  payload: {
    breadcrumbs: Array<{
      id: string;
      name: string;
    }>;
  };
}

export interface IContentBrowserGetBreadcrumbsFailureAction {
  type: typeof CONTENT_BROWSER_GET_BREADCRUMBS_FAILURE;
  payload: Error;
}

export interface IContentBrowserSelectFolderAction {
  type: typeof CONTENT_BROWSER_SELECT_FOLDER;
  payload: {
    folderId: string;
  };
}

export interface IContentBrowserSelectContentAction {
  type: typeof CONTENT_BROWSER_SELECT_CONTENT;
  payload: {
    contentId: string;
  };
}

export interface IContentBrowserSetSearchQueryAction {
  type: typeof CONTENT_BROWSER_SET_SEARCH_QUERY;
  payload: {
    query: string;
  };
}

export interface IContentBrowserToggleSelectAllAction {
  type: typeof CONTENT_BROWSER_TOGGLE_SELECT_ALL;
  payload: {
    visibleFolderIds: string[];
    visibleContentIds: string[];
  };
}

export interface IContentBrowserMoveItemsRequestAction {
  type: typeof CONTENT_BROWSER_MOVE_ITEMS_REQUEST;
  payload: {
    contentIds: string[];
    folderIds: string[];
    targetFolderId: string;
    targetWorkspaceId: string;
  };
}

export interface IContentBrowserMoveItemsSuccessAction {
  type: typeof CONTENT_BROWSER_MOVE_ITEMS_SUCCESS;
  payload: {
    contentIds: string[];
    folderIds: string[];
    targetFolderId: string;
    targetWorkspaceId: string;
  };
}

export interface IContentBrowserMoveItemsFailureAction {
  type: typeof CONTENT_BROWSER_MOVE_ITEMS_FAILURE;
  payload: {
    error: Error;
    contentIds: string[];
    folderIds: string[];
    originalData: {
      contentItems: Array<{
        id: string;
        folder_id: string;
        workspace_id: string;
      }>;
      folderItems: Array<{
        id: string;
        parent_id: string;
        workspace_id: string;
      }>;
    };
  };
}

export interface IContentBrowserUploadStartedAction {
  type: typeof CONTENT_BROWSER_UPLOAD_STARTED;
  payload: {
    uploadId: string;
    fileName: string;
    fileSize: number;
    fileType: string;
    workspaceId: string;
    folderId: string;
  };
}

export interface IContentBrowserUploadProgressUpdatedAction {
  type: typeof CONTENT_BROWSER_UPLOAD_PROGRESS_UPDATED;
  payload: {
    uploadId: string;
    progress: IH5PUploadProgress;
  };
}

export interface IContentBrowserUploadCompletedAction {
  type: typeof CONTENT_BROWSER_UPLOAD_COMPLETED;
  payload: {
    uploadId: string;
    contentId: string;
  };
}

export interface IContentBrowserUploadFailedAction {
  type: typeof CONTENT_BROWSER_UPLOAD_FAILED;
  payload: {
    uploadId: string;
    error: {
      message: string;
      code: string;
      details?: string;
    };
  };
}

export interface IContentBrowserUploadCancelledAction {
  type: typeof CONTENT_BROWSER_UPLOAD_CANCELLED;
  payload: {
    uploadId: string;
  };
}

export interface IContentBrowserUploadRemovedAction {
  type: typeof CONTENT_BROWSER_UPLOAD_REMOVED;
  payload: {
    uploadId: string;
  };
}

export interface IContentBrowserUploadsClearedAction {
  type: typeof CONTENT_BROWSER_UPLOADS_CLEARED;
}

// Union type for all content browser actions
export type ContentBrowserActionTypes =
  | IContentBrowserSetCurrentFolderAction
  | IContentBrowserSetDisplayModeAction
  | IContentBrowserSetSelectedFoldersAction
  | IContentBrowserSetSelectedContentAction
  | IContentBrowserResetSelectionAction
  | IContentBrowserCutItemsAction
  | IContentBrowserPasteItemsAction
  | IContentBrowserClearClipboardAction
  | IContentBrowserRemoveClipboardItemAction
  | IContentBrowserSearchRequestAction
  | IContentBrowserSearchSuccessAction
  | IContentBrowserSearchFailureAction
  | IContentBrowserGetBreadcrumbsRequestAction
  | IContentBrowserGetBreadcrumbsSuccessAction
  | IContentBrowserGetBreadcrumbsFailureAction
  | IContentBrowserSelectFolderAction
  | IContentBrowserSelectContentAction
  | IContentBrowserSetSearchQueryAction
  | IContentBrowserToggleSelectAllAction
  | IContentBrowserMoveItemsRequestAction
  | IContentBrowserMoveItemsSuccessAction
  | IContentBrowserMoveItemsFailureAction
  | IContentBrowserUploadStartedAction
  | IContentBrowserUploadProgressUpdatedAction
  | IContentBrowserUploadCompletedAction
  | IContentBrowserUploadFailedAction
  | IContentBrowserUploadCancelledAction
  | IContentBrowserUploadRemovedAction
  | IContentBrowserUploadsClearedAction;
